<template>
  <div class="studyplan-email">
    <!-- 背景图 -->
    <div class="emailcard_base">
      <!-- 卡片背景 -->
      <div class="emailcard">
        <!-- 友邻LOGO -->
        <div class="bg-head">
          <div class="emailcard_logo"></div>
        </div>
        <div class="bg-body">
          <div class="title">
            {{ user.nickName }} 同学，你好！
          </div>
          <div class="content">
            <div class="line" v-html="termInfo.intro && termInfo.intro.replace(/\n/g, '<br />')">
              <!-- {{termInfo.intro}} -->
              <!-- 欢迎进入{{ schoolName }}{{ termInfo.termName }}选课系统。本学期，我们共开设{{ planCount }}个学习计划：阅读力计划、沟通力计划、灯塔计划。 -->
            </div>
            <!-- <div class="line">
              <p>申请加入前，请确认：</p>
              <p>· 学好英语，对你而言很重要；</p>
              <p>· 每天，你能为英语学习安排至少1小时；</p>
              <p>· 你能按照计划，认真完成指定的学习任务。</p>
            {{ termInfo.termName }}，友邻学院将贯彻「重度学习」原则。在申请加入之前，请确定你愿意为英语学习,每天投入1-2小时。
            </div>
              <div class="line">
              <p>选课前，请认真阅读课程介绍，选择一个最适合自己的计划。</p>
              选课前，请认真阅读课程介绍，选择一个最适合自己的计划，坚持{{ timeCount }}个月。
            </div>  -->
          </div>
        </div>
      </div>
        <!-- 波浪线 -->
        <div class="emailcard_wavy_line"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'studyplan-email',
  data() { 
    return {
      schoolName: '友邻学院'
    }
  },
  computed: {
    ...mapGetters('user/login', [
      'getWXUser',
      'user', // 取 appUser 或者 getWXUser
      'jssdkConfig'
    ]),
    ...mapGetters('goods/vip', [
      'termInfo',
      // 限购规则
      'limitData'
    ]),
    planCount() {
      return this.termInfo.planCountName
    },
    timeCount() {
      // return this.termInfo.timeCount || '三'
      // 后端没有timeCount这个字段，后台管理没有绑定这个字段的输入框，先用天数计算月
      return Math.round(this.termInfo.termDays / 30) || '1'
    }
  }
}
</script>

<style lang="less" scoped>
.studyplan-email {
  .emailcard_base {
    background: url("../../../../../images/goods-studyplan/emailcard_bg_base.png") no-repeat;
    background-size: 100% 100%;
    //height: 8rem;
    padding-top: 0.75rem;
    .emailcard {
      margin: 0 0.56rem;
      margin-bottom: -0.2rem;
      background-size: 100% 100%;
      .bg-head{
        background: url("../../../../../images/goods-studyplan/bg-head.png") no-repeat;
        background-size: 100% 100%;
        height: 1.17rem;
      }
      .bg-body{
        background: url("../../../../../images/goods-studyplan/bg-body.png") no-repeat;
        background-size: 100% 100%;
        padding: 0.37rem;
      }
      //height: 8rem;
      .emailcard_logo {
        //background: url("../../../../../images/goods-studyplan/emailcard_logo.png") no-repeat;
        background-size: 100% 100%;
        height: 0.72rem;
      }
      .title {
        padding: 0.37rem 0;
        color: #E7BF9A;
        font-size: 0.3rem;
        font-weight: bold;
        line-height: 0.44rem;
      }
      .content {
        color: #E7BF9A;
        font-size: 0.26rem;
        padding-bottom: .5rem;
        .line {
          margin-bottom: 0.2rem;
          line-height: 0.44rem;
        }
      }
    }
    .emailcard_wavy_line {
      position: relative;
      margin-top: -0.9rem;
      background: url("../../../../../images/goods-studyplan/emailcard_wavy_line.png") no-repeat;
      background-size: 100% 100%;
      height: 0.72rem;
    }
  }
}
</style>